var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPageContainer',{attrs:{"image":_vm.image,"number":"404","message":_vm.message}})}
var staticRenderFns = []

export { render, staticRenderFns }